<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 15 14">
    <path d="M7 11l2.625-3h-6l-2.625 3h6zM14.914 2.586c0.156 0.359 0.094 0.773-0.164 1.070l-7 8c-0.187 0.219-0.461 0.344-0.75 0.344h-6c-0.391 0-0.75-0.227-0.914-0.586-0.156-0.359-0.094-0.773 0.164-1.070l7-8c0.187-0.219 0.461-0.344 0.75-0.344h6c0.391 0 0.75 0.227 0.914 0.586z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-eraser.html